﻿<!-- // To Do  -->
<!-- Manage routing  via state :) 
 -->
<script>
//svelte native
import { onMount } from 'svelte';
// npm packages
import { Router, Link, Route } from "svelte-routing";
// modules
import {fetchPageData} from "./modules/fetchPageData.js";
import {selectWhere} from "./modules/selectWhere.js";
// import {ficDeMenu} from "./modules/ficMenu.js";
// components
import Header from "./components/Header.svelte";
import Footer from "./components/Footer.svelte";
import PrimaryNav from "./components/PrimaryNav.svelte";
// pages
import Home from "./pages/Home.svelte";
import About from "./pages/About.svelte";
import Visualiser from "./pages/Visualiser.svelte";
import MappingMyCommunity from "./pages/MappingMyCommunity.svelte";
import ExamplesCaseStudies from "./pages/ExamplesCaseStudies.svelte";
import TheProcess from "./pages/TheProcess.svelte";
import Exploringunderstory from "./pages/Exploringunderstory.svelte";
import TheCommunityMaps from "./pages/TheCommunityMaps.svelte";
import Page404 from "./pages/Page404.svelte";
import OurMission from "./pages/OurMission.svelte";
import Test from "./pages/Test.svelte";
import PlainPage from "./pages/PlainPage.svelte";
import MailchimpSignupPage from "./pages/MailchimpSignupPage.svelte";
//
import 'vanilla-cookieconsent/dist/cookieconsent.js';



export let url1 = "";

	let mode = "dev";
	let pageContent;
  let contentItem = '';
  let basicContent = '';
  let footerContent = '';
  let promise;
  let txt = '';
  let header ="empty";
  let textfeild01 = "nothing";

  let mapView = false;

//load data
onMount(async  () =>{
    
    basicContent = await fetchPageData("page-elements","General");
    footerContent = await fetchPageData("footers","General");
    header = await selectWhere(basicContent, "locationOnPage", "head-1");

});
//



</script>
<svelte:head>

<link rel="stylesheet" href="/styles/styles.css">
<link rel="stylesheet" href="https://cdn.jsdelivr.net/gh/orestbida/cookieconsent@v2.8.9/dist/cookieconsent.css">

</svelte:head>

<!-- Routing -->
<Router url="{url1}">

  {#if basicContent }

    <Header title={header.Title} strapline={header.Copy}   />

      {:else}
      ...loading
  {/if}
  <!-- </Route> -->
   


   <!-- Main Content -->
 
<main class="page-content" aria-label="Content">
  <!--  -->
   {#if !mapView}
        <div id="fic--background">

      
          </div>


  {/if}

<!-- // {#if basicContent} -->
  <div class= "main">
    
    <Route path ="/mappingmycommunity"><PlainPage page={"Mapping my community"} /></Route>
    <Route path ="/examplescasestudies"><PlainPage page={"Examples / case studies"} /></Route>
    <Route path ="/about"><PlainPage page={"About"} /></Route>
    <Route path ="/theprocess"><PlainPage page={"The process"} /></Route>
    <Route path ="/exploringunderstory"><PlainPage page={"Exploring the Understory"} /></Route>
    <Route path ="/thecommunitymaps"><TheCommunityMaps /></Route>
    <Route path ="/visualiser/:id" let:params> <Visualiser project_id="{params.id}"/> </Route>
    <Route path ="/ourmission"> <PlainPage page={"Theory"} /> </Route>
    <Route path ="/"><PlainPage page={"frontpage"} /></Route>
    <Route path ="/privacypolicy"> <PlainPage page={"privacypolicy"} /> </Route>
    <Route path ="/termsandconditions">  <PlainPage page={"terms and conditions"} /> </Route>
    <Route path ="/partnershipagreement"> <PlainPage page={"partnership agreement"} /> </Route>
    <Route path ="/test"><Test /></Route>
    <Route path ="/newsletter"> <MailchimpSignupPage  /> </Route>
    <Route path ="/news"><PlainPage page={"News"}/></Route>
    <Route path ="/tutorials"><PlainPage page={"Tutorials"}/></Route>
    <Route ><Page404 /></Route>
  </div>
  <!-- {/if} -->
	
  <!-- <div class ="footer puff"> Footer - content </div> -->

  </main>
{#if footerContent}
  <Footer footerStuff={footerContent}/>
{:else}
...loading
{/if}

  <!-- Inline script -->
    <script>
        window.addEventListener('load', function(){

            // obtain plugin
            var cc = initCookieConsent();

            // run plugin with your configuration
            cc.run({
                current_lang: 'en',
                autoclear_cookies: true,                   // default: false
                page_scripts: true,                        // default: false

                // mode: 'opt-in'                          // default: 'opt-in'; value: 'opt-in' or 'opt-out'
                // delay: 0,                               // default: 0
                // auto_language: '',                      // default: null; could also be 'browser' or 'document'
                // autorun: true,                          // default: true
                // force_consent: false,                   // default: false
                // hide_from_bots: true,                   // default: true
                // remove_cookie_tables: false             // default: false
                // cookie_name: 'cc_cookie',               // default: 'cc_cookie'
                // cookie_expiration: 182,                 // default: 182 (days)
                // cookie_necessary_only_expiration: 182   // default: disabled
                // cookie_domain: location.hostname,       // default: current domain
                // cookie_path: '/',                       // default: root
                // cookie_same_site: 'Lax',                // default: 'Lax'
                // use_rfc_cookie: false,                  // default: false
                // revision: 0,                            // default: 0

                onFirstAction: function(user_preferences, cookie){
                    // callback triggered only once on the first accept/reject action
                },

                onAccept: function (cookie) {
                    // callback triggered on the first accept/reject action, and after each page load
                },

                onChange: function (cookie, changed_categories) {
                    // callback triggered when user changes preferences after consent has already been given
                },

                languages: {
                    'en': {
                        consent_modal: {
                            title: 'We use cookies!',
                            description: 'We use cookies to analyse how you use the site in order to improve your experience here. We do not use cookies to serve ads. You can accept, select or reject cookies below. <button type="button" data-cc="c-settings" class="cc-link">Let me choose</button>',
                            primary_btn: {
                                text: 'Accept all',
                                role: 'accept_all'              // 'accept_selected' or 'accept_all'
                            },
                            secondary_btn: {
                                text: 'Reject all',
                                role: 'accept_necessary'        // 'settings' or 'accept_necessary'
                            }
                        },
                        settings_modal: {
                            title: 'Cookie preferences',
                            save_settings_btn: 'Save settings',
                            accept_all_btn: 'Accept all',
                            reject_all_btn: 'Reject all',
                            close_btn_label: 'Close',
                            // cookie_table_caption: 'Cookie list',
                            cookie_table_headers: [
                                {col1: 'Name'},
                                {col2: 'Domain'},
                                {col3: 'Expiration'},
                                {col4: 'Description'}
                            ],
                            blocks: [
                                {
                                    title: 'Cookie usage 📢',
                                    description: 'We use cookies to ensure that the website functions effectively and to improve the user experience.  You can choose to opt in or out of any of these categories whenever you want.'
                                },  {
                                    title: 'Analytics cookies',
                                    description: 'We only use cookies for analysis, its useful to us to know how this site is being used. but you are able to opt out of these cookies if you choose to.',
                                    toggle: {
                                        value: 'analytics',     // your cookie category
                                        enabled: false,
                                        readonly: false
                                    },
                                    
                                }, 

                            ]
                        }
                    }
                },

                gui_options: {
                    consent_modal: {
                        layout: 'box',               // box/cloud/bar
                        position: 'bottom left',     // bottom/middle/top + left/right/center
                        transition: 'slide',           // zoom/slide
                        swap_buttons: false            // enable to invert buttons
                    },
                    settings_modal: {
                        layout: 'bar',                 // box/bar
                        // position: 'left',           // left/right
                        transition: 'slide'            // zoom/slide
                    }
                }
            });
        });
    </script>
</Router>

<style>
 
</style>